import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 202 862",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9327 0H201.933V862H7.43359C7.43359 862 -9.29104 668.686 7.43275 542.5C35.2728 332.438 17.9327 0 17.9327 0Z",
			fill: "url(#paint0_linear_10372_10343)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.4336 0H104.934V862H47.1423C47.1423 862 42.1729 668.686 47.142 542.5C55.4141 332.438 71.4336 0 71.4336 0Z",
			fill: "#2A4571"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.042 0H178.934V862H139.443C139.443 862 136.047 668.686 139.443 542.5C145.095 332.438 156.042 0 156.042 0Z",
			fill: "#2A4571"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10372_10343",
			x1: 52.4336,
			y1: 453.5,
			x2: 17.9336,
			y2: 451.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#355383" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#45679D"
			})]
		}) })
	]
});
const SvgCurtain = styled(base)({});
export default SvgCurtain;
